import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Container,
  Paper,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import { Business as BusinessIcon, Person as PersonIcon } from '@mui/icons-material';

const MainPage: React.FC = () => {
  const navigate = useNavigate();

  const handleUserTypeSelect = (type: 'candidate' | 'recruiter') => {
    if (type === 'candidate') {
      navigate('/interview');
    } else if (type === 'recruiter') {
      navigate('/admin');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={8}
          sx={{
            p: 4,
            borderRadius: 3,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              background: 'linear-gradient(45deg, #10b981, #059669)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 2,
            }}
          >
            Talent Hub
          </Typography>

          <Typography variant="h6" color="text.secondary" gutterBottom sx={{ mb: 4 }}>
            AI面接システム
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            ご利用される立場を選択してください
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 3,
              justifyContent: 'center',
            }}
          >
            <Box sx={{ flex: '1 1 300px', maxWidth: '400px' }}>
              <Card
                sx={{
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: 6,
                  },
                }}
                onClick={() => handleUserTypeSelect('candidate')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <PersonIcon
                    sx={{
                      fontSize: 64,
                      color: 'primary.main',
                      mb: 2,
                    }}
                  />
                  <Typography variant="h5" component="h2" gutterBottom>
                    候補者
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    AI面接を受ける
                  </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      borderRadius: 2,
                      px: 4,
                    }}
                  >
                    面接を開始
                  </Button>
                </CardActions>
              </Card>
            </Box>

            <Box sx={{ flex: '1 1 300px', maxWidth: '400px' }}>
              <Card
                sx={{
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: 6,
                  },
                }}
                onClick={() => handleUserTypeSelect('recruiter')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <BusinessIcon
                    sx={{
                      fontSize: 64,
                      color: 'secondary.main',
                      mb: 2,
                    }}
                  />
                  <Typography variant="h5" component="h2" gutterBottom>
                    採用担当者
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    候補者管理・評価確認
                  </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    sx={{
                      borderRadius: 2,
                      px: 4,
                    }}
                  >
                    管理画面へ
                  </Button>
                </CardActions>
              </Card>
            </Box>
          </Box>

          <Box sx={{ mt: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Talent Hub POC - AI面接システム
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default MainPage;
